import { gql } from '@apollo/client';

export const RUNNER_FIELDS = gql`
  fragment RunnerFields on Runner {
    runner_id
    race_id
    tab_number
    barrier
    horse_id
    horse_name
    jockey
    jockey_id
    trainer
    trainer_id
    weight
    scratching {
      reason
      scratched_at
    }
  }
`;
